export default {
  name: "MenuButton",
  functional: true,
  props: {
    button: {
      type: Object,
      default() {
        return {};
      }
    },
    owner: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  render(h, _vm) {
    const props = _vm.props;
    const { owner, button } = props;
    let popoverShow = ()=>{
      owner.childOpenId = button.id;
    }
    let popoverClose = ()=>{
      if(owner.childOpenId == button.id){
        owner.childOpenId = null;
      }
    }
    return (
      <el-popover
        popper-class="ds-childrenbutton-popover"
        placement="top-start"
        width="auto"
        trigger={button.trigger}
        class={["ds-button__more", owner.size, owner.childOpenId==button.id?'childOpen':'']}
        visible-arrow={false}
        on={{
          show: popoverShow,
          hide: popoverClose
        }}
      >
        {renderButtons(h, _vm)}
        {rendreMainButton(h, _vm)}
      </el-popover>
    );
  }
};
function renderButtons(h, _vm) {
  const props = _vm.props;
  const { button, owner } = props;
  return (
    <div class="ds-childrenbuttons-menu">
      <DsfButtonBar
        is-design={owner.isDesign}
        ref="buttonbarchildrenbutton"
        more-button-style={owner.moreButtonStyle}
        more-button-text={owner.moreButtonText}
        max-number={1000}
        buttons={button.children}
        icon-position={button.iconPosition}
        render-button={owner.renderButton}
        local={owner.local}
        class={{ "ds-no-padding": true }}
      ></DsfButtonBar>
    </div>
  );
}
function rendreMainButton(h, _vm) {
  const props = _vm.props;
  const { button, owner } = props;
  return (
    <DsfButton
      slot="reference"
      key={`reference_${button.id}`}
      icon={owner.getIcon(button)}
      title={button.title}
      disabled={button.disabled}
      size={owner.size}
      type={button.type}
      btn-style={button.btnStyle}
      icon-position={button.iconPosition}
      style={button.style}
      loading={button.loading}
      hasChild={true}
      on-click={($event) => {
        owner.clickHandler(button, $event);
      }}
    >
      {button.text}
    </DsfButton>
  );
}
